module.exports = __webpack_public_path__ + "img/_tune-vertical-variant.80cac547.svg";